import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  OAuthProvider,
  signInWithRedirect,
} from "firebase/auth";
import { auth, db } from "../lib/firebase";
import { doc, setDoc } from "firebase/firestore";

export async function loginWithAuthentik() {
  const provider = new OAuthProvider("oidc.mareserve");
  return signInWithRedirect(auth, provider);
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);

  const handleAuth = async () => {
    try {
      let userCred;

      if (isRegister) {
        userCred = await createUserWithEmailAndPassword(auth, email, password);

        await setDoc(
          doc(db, "users", userCred.user.uid),
          {
            email,
            name: "",
            alertDays: 7,
            createdAt: new Date().toISOString(),
            lastHouseId: "",
            lastAlert: null,
          },
          { merge: true }
        );
      } else {
        userCred = await signInWithEmailAndPassword(auth, email, password);
      }
    } catch (e) {
      alert(e.message);
    }
  };

  return (
    
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">
          🏠 <span>Ma Réserve</span>
        </div>

        {/* <h2 className="login-title">
          {isRegister ? "Créer un compte" : "Connexion"}
        </h2>*/}

        <p className="login-sub">
          Gérez vos aliments, évitez le gaspillage
        </p>

        <div className="login-form">
          {/*<input
            className="login-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            className="login-input"
            placeholder="Mot de passe"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="button" className="login-btn" onClick={handleAuth}>
            {isRegister ? "Créer mon compte" : "Se connecter"}
          </button>*/}

          <button type="button" className="login-btn" onClick={loginWithAuthentik}>
            Se connecter avec Authentik
          </button>

          {/*<button type="button" className="login-switch" onClick={() => setIsRegister(!isRegister)}>
            {isRegister ? "J'ai déjà un compte" : "Créer un compte"}
          </button>*/}
        </div>
      </div>
    </div>
  );
}